import { fromJS } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import * as actionTypes from './constants'

const initialState = fromJS({})

function planVersionsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PLAN:
      return state
        .set('gettingPlan', true)
        .delete('getPlanError')
        .delete('plan')
    case actionTypes.GET_PLAN_DONE:
      return state.set('gettingPlan', false).set('plan', action.plan)
    case actionTypes.GET_PLAN_ERROR:
      return state.set('gettingPlan', false).set('getPlanError', action.error)

    case actionTypes.UPDATE_PLAN:
    case actionTypes.UPDATE_PLANS_BATCH:
      return state.set('updatingPlan', true).delete('updatePlanError')
    case actionTypes.UPDATE_PLAN_DONE:
      return state.set('updatingPlan', false)
    case actionTypes.UPDATE_PLAN_ERROR:
    case actionTypes.UPDATE_PLANS_BATCH_ERROR:
      return state
        .set('updatingPlan', false)
        .set('updatePlanError', action.error)

    case actionTypes.UPDATE_PLANS_BATCH_DONE:
      return state.set('updatingPlan', false)

    case actionTypes.RESET_PIN_ERROR:
      return state.set('resetPinError', action.error)

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default planVersionsReducer
